import { Button, message, Popconfirm } from "antd"
import React from "react"
import { doc, runTransaction, serverTimestamp } from "firebase/firestore"
import { db } from "../../../../firebase/config"

export default function DeleteInvoice({ record, invoice }) {
  const handleDelete = async () => {
    const targetCollection = invoice ? "deletedInvoices" : "deletedProformas"
    const originalCollection = invoice ? "invoices" : "proformas"

    const originalRef = doc(db, originalCollection, record.id)
    const deletedRef = doc(db, targetCollection, record.id) // keep same id

    try {
      await runTransaction(db, async (tx) => {
        // Always read the latest server data instead of trusting `record`
        const snap = await tx.get(originalRef)
        if (!snap.exists()) {
          throw new Error("Document no longer exists.")
        }

        const data = snap.data()

        // Write to deleted collection with metadata
        tx.set(deletedRef, {
          ...data,
          deletedAt: serverTimestamp(),
          originalPath: `${originalCollection}/${record.id}`,
        })

        // Hard delete original
        tx.delete(originalRef)
      })

      message.success(`Moved to ${targetCollection} and removed from ${originalCollection}.`)
    } catch (error) {
      console.error(error)
      message.error("Error moving record: " + error.message)
    }
  }

  return (
    <Popconfirm
      title="Are you sure to delete this?"
      onConfirm={handleDelete}
      okText="Yes"
      cancelText="No">
      <Button size="small" danger>
        Delete
      </Button>
    </Popconfirm>
  )
}
